import PropTypes from 'prop-types';
import { Component } from 'react';
import Constants, { getTypeByColor } from './Constants';
import Flux from '../../flux/Flux';
import { setCookie } from '../../utils/CommonUtils';
import Alert, { BUTTON } from '../Alert/Alert';

class StatusBarEmailVerified extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isVisible: this.props.isVisible,
		};
	}

	render() {
		if (!this.state.isVisible) {
			return null;
		}
		const onClick = () => {
			setCookie(Flux.Constants.CookieNames.STATUS_BAR_EMAIL_VERIFIED, '0', 0, '/', '', true, Flux.Constants.CookieSameSiteAttributes.LAX);

			if (this.props.targetUrl) {
				window.location.href = this.props.targetUrl;
			} else {
				this.setState({
					isVisible: false,
				});
			}
		};

		return (
			<Alert
				type={getTypeByColor(this.props.barColor)}
				headline={this.props.msgIntro.replace(':guestName', Flux.Guest.getName()).replace(':guestMail', Flux.Guest.getEmailAddress())}
				text={this.props.msgOutro}
				buttons={[{ type: BUTTON.SECONDARY, text: this.props.btnLabel, onClick: onClick }]}
			/>
		);
	}
}

StatusBarEmailVerified.propTypes = {
	barColor: PropTypes.string.isRequired,
	msgIntro: PropTypes.string.isRequired,
	msgOutro: PropTypes.string.isRequired,
	btnLabel: PropTypes.string.isRequired,
	targetUrl: PropTypes.string,
	isVisible: PropTypes.bool.isRequired,
};

StatusBarEmailVerified.defaultProps = {
	barColor: Constants.BARCOLOR_GREY,
};

export default StatusBarEmailVerified;
